export const Props = () => ({
  //Активный item?
  isActive: { type: Boolean },

  //Текст item
  text: { type: String },

  //Тип отображаемой иконки
  icon: {
    type: String,
    required: false,
    validator: (value) => ['clock', 'star', 'filter'].includes(value)
  },

  //Может ли элемент быть кликабельным (показывать стрелку)
  isClickable: { type: Boolean },

  //Развернуто ли состояние (для поворота стрелки)
  isExpanded: { type: Boolean },
});